import * as React from 'react';
import { useEffect, useState } from 'react';
import { Link } from 'gatsby';
import { useTheme } from 'styled-components';

import { useLocation } from '@reach/router';

import { ReactComponent as OpenIcon } from '../../assets/icons/burger-open.svg';
import { ReactComponent as Logo } from '../../assets/icons/orange-logo.svg';
import { ReactComponent as PurpleLogo } from '../../assets/icons/purple-logo.svg';
import useHeaderMenuIconColor from '../../hooks/use-header-menu-icon-color';
import { useMatchMedia } from '../../hooks/use-match-media';
import { ScContainer } from '../container/styled';
import { CustomButton } from '../custom-button';
import {
	BIKE_LOGIN_TITLE,
	bikePortalsMenuGroup,
	CONTACT_US_FORM_TITLE,
	CONTACT_US_FORMS,
	firstLinksRow,
	NURSERY_LOGIN_TITLE,
	nurseryPortalsMenuGroup,
} from '../footer/helpers';
import helmet from '../../assets/images/helmet_product_bike.png';
import hands from '../../assets/images/nursery-hands.png';

import { Dropdown } from './dropdown';
import { Sidebar } from './sidebar';
import { ScHeaderNavigation, ScHeaderNavigationList, ScHeaderWrapper } from './styled';

const listPagesWithPurpleLogo = [
	'404',
	'gogeta-cycle-to-work-scheme',
	'employee-tech',
	'employer-tech',
	'provider-tech',
];

export const Header = ({ openModal }: { openModal: (modalType: string) => void }) => {
	const theme = useTheme();
	const isDesktop = useMatchMedia(`(min-width: 1220px)`);
	const [isOpenSidebar, setIsOpenSidebar] = useState(false);
	const color = useHeaderMenuIconColor();
	const location = useLocation();

	useEffect(() => {
		if (isOpenSidebar) {
			document.body.style.overflow = 'hidden';
		} else {
			document.body.style.overflow = '';
		}

		return () => {
			document.body.style.overflow = '';
		};
	}, [isOpenSidebar]);

	const sidebarHandler = (itemType?: string) => {
		setIsOpenSidebar(!isOpenSidebar);

		if (itemType) {
			if (itemType === CONTACT_US_FORMS.BIKE) {
				openModal(CONTACT_US_FORMS.BIKE);
			} else {
				openModal(CONTACT_US_FORMS.NURSERY);
			}
		}
	};

	const contactUsItems = [
		{
			title: 'Gogeta Bike',
			onClick: () => openModal(CONTACT_US_FORMS.BIKE),
		},
		{
			title: 'Gogeta Nursery',
			onClick: () => openModal(CONTACT_US_FORMS.NURSERY),
		},
	];

	const loginItems = [
		{
			title: 'Gogeta Nursery',
			icon: hands,
			group: nurseryPortalsMenuGroup,
		},
		{
			title: 'Gogeta Bike',
			icon: helmet,
			group: bikePortalsMenuGroup,
		},
	];

	useEffect(() => setIsOpenSidebar(false), [location]);

	const linksRow = firstLinksRow.filter(
		(row) =>
			row.title !== CONTACT_US_FORM_TITLE &&
			row.title !== NURSERY_LOGIN_TITLE &&
			row.title !== BIKE_LOGIN_TITLE,
	);

	return (
		<ScContainer>
			<ScHeaderWrapper burgerIconColor={color}>
				{listPagesWithPurpleLogo.find((x) => location.pathname.includes(x)) ? (
					<Link to={'/'}>
						<PurpleLogo />
					</Link>
				) : (
					<Link to={'/'}>
						<Logo />
					</Link>
				)}
				{isDesktop ? (
					<ScHeaderNavigation>
						<ScHeaderNavigationList>
							{linksRow.map((item) => (
								<Dropdown item={item} key={item.title} />
							))}
						</ScHeaderNavigationList>
						<CustomButton
							hoverBackground={
								location.pathname.includes('404') ? theme.colors.blueberry : theme.colors.marmelade
							}
							hoverColor={theme.colors.darkText}
							dropdownItems={loginItems}
							isMenuItem
						>
							Log in
						</CustomButton>
						<CustomButton
							hoverBackground={
								location.pathname.includes('404') ? theme.colors.blueberry : theme.colors.marmelade
							}
							hoverColor={theme.colors.darkText}
							dropdownItems={contactUsItems}
						>
							Contact us
						</CustomButton>
					</ScHeaderNavigation>
				) : isDesktop === false && !isOpenSidebar ? (
					<OpenIcon className="burger-icon" onClick={() => sidebarHandler()} />
				) : (
					<></>
				)}
			</ScHeaderWrapper>
			{isDesktop === false && (
				<Sidebar sidebarHandler={(itemType) => sidebarHandler(itemType)} isOpen={isOpenSidebar} />
			)}
		</ScContainer>
	);
};
